import {
  ArmyListUnitOption,
  UnitOption,
  UnitOptionAvailabilityAction,
  UnitOptionUsePoint,
} from '@Models';

export const computeOptionPoints = (
  option: UnitOption,
  armyListUnitOptions: Array<ArmyListUnitOption>,
): number | null => {
  const modifiers = option.availabilities
    .filter((item) => item.action == UnitOptionAvailabilityAction.ChangePoints)
    .filter((item) =>
      armyListUnitOptions.some((o) => o.unit_option_id == item.unitOptionId),
    )
    .map((item) => {
      if (item.usePoints == UnitOptionUsePoint.Free) return 0;

      return item.value;
    })
    .filter((item): item is number => item != null);

  if (modifiers.length == 0) {
    if (option.use_points === UnitOptionUsePoint.NoLimit) return null;

    return option.points;
  }

  return Math.min.apply(Math, modifiers);
};
